__turbopack_context__.v({
  "container": "_1SKLRq_container",
});
